module.exports = __webpack_public_path__ + "img/agility_test_button.07dda76f.jpg";